module.exports = __webpack_public_path__ + "static/media/20ECE18.3c874d41.jpg";